<template>
    <div class="home-view">
        <!-- 輪播圖 -->
        <van-swipe class="banner-view-box" :autoplay="3000">
            <!-- json -->
            <van-swipe-item v-for="(item, index) in banner" :key="index" class="banner-view">
                <img :src="item.img" />
            </van-swipe-item>
            <!-- 陣列 -->
            <!-- <van-swipe-item
        class="banner-view"
        v-for="(image, index) in images"
        :key="index">
        <img :src="image" v-lazy="image"/>
        </van-swipe-item> -->
            <!-- 基礎 -->
            <!-- <van-swipe-item>
        <img src="https://picsum.photos/600/200?random=1" alt=""/></van-swipe-item>
        <van-swipe-item>
        <img src="https://picsum.photos/600/200?random=2" alt=""/></van-swipe-item>
        <van-swipe-item>
        <img src="https://picsum.photos/600/200?random=3" alt=""/></van-swipe-item>
        <van-swipe-item>
        <img src="https://picsum.photos/600/200?random=4" alt=""/></van-swipe-item> -->
        </van-swipe>
        <!-- 分類紐 -->
        <categoryView></categoryView>
        <!-- 單品熱賣 -->
        <titleView name="單品熱賣" icon="star-o"></titleView>
        <sellingView> </sellingView>
        <!-- 精選活動 -->
        <titleView name="精選活動" icon="gift-o"> </titleView>
        <winnowView :bigImg="winnowBig1" :contents="winnowContents1"></winnowView>
        <winnowView :bigImg="winnowBig2" :contents="winnowContents2"></winnowView>
        <!-- 為你推薦 -->
        <titleView name="為你推薦" icon="label-o"> </titleView>
        <commendView></commendView>
        <!-- 商品詳情 -->
        <transition name="slide-to-left">
            <goodsDetailView v-if="goodsDetailShow"></goodsDetailView>
        </transition>
    </div>
</template>

<script>
    // import navViewVue from "./navView/navView.vue";
    //輪播圖導入
    import Vue from "vue";
    import { Swipe, SwipeItem } from "vant";
    Vue.use(Swipe).use(SwipeItem);
    import categoryView from "../categoryView/categoryView.vue";
    import titleView from "../titleView/titleView.vue";
    import sellingView from "../sellingView/sellingView.vue";
    import winnowView from "../winnowView/winnowView.vue";
    import commendView from "../commendView/commendView.vue";
    import goodsDetailView from "../goodsDetailView/goodsDetailView.vue";
    export default {
        name: "homeView",
        components: {
            titleView,
            categoryView,
            sellingView,
            winnowView,
            commendView,
            goodsDetailView,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
        },
        computed: {// 添加计算属性
            goodsDetailShow() {// 获取对应的状态
                return this.$store.state.goodsDetailShow
            }
        },
        data() {
            return {
                title: "Sandra眼鏡商城",
                navViewShow: true,
                // json-->banner
                banner: [],
                //陣列
                // images: [
                //   "https://picsum.photos/600/200?random=1",
                //   "https://picsum.photos/600/200?random=2",
                //   "https://picsum.photos/600/200?random=3"
                // ]
                winnowBig1: "",
                winnowContents1: [],
                winnowBig2: "",
                winnowContents2: [],
                // goodsDetailShow: true
            };
        },
        created() {
            // console.log(this.title);
            // 創建時，發送標題
            this.$emit("onTitle", this.title);
            this.$emit("onNavShow", this.navViewShow);
            // 獲取輪播圖數據;
            var that = this;
            this.$ajax.get("/json/banner.json").then(function (response) {
                //獲取數據成功
                // console.log(response);
                that.banner = response.data;
            });
            // .catch(function(err) {
            //   //出錯
            //   // console.log(err);
            // });
            // 獲取精選活動數據;
            this.$ajax.get("/json/winnow.json").then(function (response) {
                that.winnowBig1 = response.data.bigImg1;
                that.winnowContents1 = response.data.winnowItems1;
                that.winnowBig2 = response.data.bigImg2;
                that.winnowContents2 = response.data.winnowItems2;
                console.log("精品數據獲取完成");
            });
        }
    };
</script>

<style lang="scss">
    .home-view {
        margin-top: 45px;
        padding-bottom: 45px;
        .banner-view-box {
            height: 150px;
            .banner-view {
                img {
                    width: 100%;
                }
            }
        }
    }
</style>
